import { render, staticRenderFns } from "./TwoFactorLoginV2.vue?vue&type=template&id=27a4191c"
import script from "./TwoFactorLoginV2.vue?vue&type=script&lang=ts"
export * from "./TwoFactorLoginV2.vue?vue&type=script&lang=ts"
import style0 from "./TwoFactorLoginV2.vue?vue&type=style&index=0&id=27a4191c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports